/** CS translations for Les Aiguilles Blanches */
const cs: Record<string, string> = {
  subtitle: "Simulátor rolby",
  startGame: "Začít hru",
  resumeGame: "Pokračovat",
  newGame: "Nová hra",
  // UNUSED continue: "Pokračovat",
  settings: "Nastavení",
  controls: "Ovládání",
  changelog: "Novinky",
  howToPlay: "Jak hrát",
  fullscreen: "Celá obrazovka",
  fullscreenHint: "Stiskni F pro celou obrazovku",
  exitFullscreen: "Ukončit celou obrazovku",
  back: "Zpět",
  backToGame: "Zpět do hry",
  // UNUSED loading: "Načítání...",
  inputKeyboard: "✓ Klávesnice nalezena",
  inputKeyboardOff: "✗ Žádná klávesnice",
  inputTouch: "✓ Dotykový displej nalezen",
  inputTouchOff: "✗ Dotykový displej nenalezen",
  inputGamepad: "✓ Gamepad připojen",
  inputGamepadOff: "✗ Žádný gamepad",
  updateAvailable: "Nová verze k dispozici — klepni pro obnovení",
  madeIn: "Vyrobeno s ❄️ v Savojsku",
  feedback: "Odeslat zpětnou vazbu",
  on: "✓ ZAP",
  off: "✗ VYP",
  zoneClosed: "🚫 ZÓNA UZAVŘENA",

  // Settings
  language: "Jazyk",
  accessibility: "Přístupnost",
  highContrast: "Vysoký kontrast",
  reducedMotion: "Omezený pohyb",
  showFps: "Zobrazit FPS",
  showDebug: "Ladění",
  skiStyle: "Styl",
  skiTricks: "Triky",
  skiBestCombo: "Nejlepší kombo",
  quitGame: "Ukončit hru",
  display: "Zobrazení",
  displayWindowed: "Okno",
  displayFullscreen: "Celá obrazovka",
  displayBorderless: "Bez rámečku",
  colorblindMode: "Barvoslepost",
  none: "Žádné",
  deuteranopia: "Deutan.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Pohyb",
  moveUp: "Nahoru",
  moveDown: "Dolů",
  moveLeft: "Vlevo",
  moveRight: "Vpravo",
  groom: "Upravit",
  winch: "Naviják",
  pause: "Pauza",
  keyboard: "Klávesnice",
  clickToRebind: "Klikni pro změnu",
  pressKey: "Stiskni klávesu...",
  pressGamepadButton: "Stiskni tlačítko gamepadu...",
  noGamepad: "Žádný gamepad nepřipojen",
  gamepadButtons: "Gamepad",
  saved: "Uloženo!",
  resetControls: "Obnovit vše",
  controlsReset: "Ovládání obnoveno!",
  movementSensitivity: "Citlivost",
  keyboardLayout: "Rozložení",
  customBindings: "Vlastní",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Dotyk",
  // UNUSED touchSupported: "Dotyk OK",
  noGamepadConnected: "Žádný gamepad připojen",
  gamepadDiagnostic: "Test ovladače",
  connectGamepadDiag: "Připoj ovladač pro testování",
  gamepadDiagButtons: "Tlačítka",
  gamepadDiagSticks: "Páčky",
  gamepadDiagTriggers: "Spouště",

  // Audio
  audio: "Zvuk",
  masterVolume: "Hlavní hlasitost",
  musicVolume: "Hudba",
  sfxVolume: "Zvukové efekty",
  engineVolume: "Motor",
  voiceVolume: "Hlasy",
  ambienceVolume: "Prostředí",
  mute: "Ztlumit",

  backgroundAudio: "Zvuk na pozadí",
  // Gameplay
  bonus: "Bonus",
  skiMode: "Režim sjezdu",
  ski: "Lyže",
  snowboard: "Snowboard",
  random: "Náhodný",
  skiIt: "Lyžovat!",
  rideIt: "Na prkno!",
  skiAgain: "Ještě jednou!",
  rideAgain: "Ještě jednou!",
  skiRunSpeed: "Rychlost",
  skiRunTime: "Čas",
  skiRunGates: "Brány",

  // How to Play hints
  howToPlayMove: "{keys} nebo šipky pro pohyb",
  howToPlayMoveTouch: "Použij virtuální D-pad",
  howToPlayMoveGamepad: "Levá páčka nebo D-pad pro pohyb",
  howToPlayMoveHybrid: "{keys}/šipky nebo dotykový D-pad",
  howToPlayGroom: "{groomKey} pro úpravu sněhu",
  howToPlayGroomTouch: "Drž tlačítko úpravy",
  howToPlayGroomGamepad: "pro úpravu sněhu",
  howToPlayGroomHybrid: "{groomKey} nebo drž tlačítko úpravy",
  howToPlayFuel: "Hlídej palivo a výdrž!",
  howToPlayWinch: "{winchKey} u kotvy pro naviják",
  howToPlayWinchTouch: "Drž tlačítko navijáku u kotvy",
  howToPlayWinchGamepad: "u kotvy pro naviják",
  howToPlayWinchHybrid: "{winchKey} nebo drž tlačítko navijáku u kotvy",

  // Winch
  winchSnapped: "💥 Kabel praskl!",
  winchAttached: "🔗 Naviják připojen! Drž {winchKey} pro pomoc.",
  winchActive: "NAVIJÁK",
  // UNUSED winchHint: "Stiskněte {winchKey} u kotevního sloupku pro naviják",
  // UNUSED winchHintTouch: "Držte 🔗 pro naviják",
  // UNUSED accessPath: "Servisní cesta",
  // UNUSED toPiste: "Na sjezdovku",

  // Taunts - Cliff falls
  tauntCliff1: "9 tun do rokle. Pojišťovna bude nadšená.",
  tauntCliff2: "Jean-Pierre říkal 'ne moc blízko k okraji!' Pamatuješ?",
  tauntCliff3: "Horská služba sjíždí s lany. Zase.",
  tauntCliff4: "Marie ruší tvoji rezervaci na raclette na dnešní večer.",
  tauntCliff5: "Thierry už počítá náklady na opravu...",

  // Taunts - Fuel empty
  tauntFuel1: "Ukazatel byl na červené 10 minut. Na co ses díval?",
  tauntFuel2: "Émilie napsala 'NATANKOVAT' velkými písmeny na tabuli.",
  tauntFuel3: "I nafta má své limity. Ty zřejmě taky.",
  tauntFuel4: "Jean-Pierre vzdychá. Posílá Thierryho s kanystrem.",
  tauntFuel5: "Slunce vychází. Sjezdovka není upravená. Lyžaři přijíždějí.",

  // Taunts - Time limit
  tauntTime1: "První lanovka za 3... 2... 1... Nestihl jsi.",
  tauntTime2: "Lyžaři objeví tvoji sjezdovku. Hrbolatá. Ledová. Nádhera.",
  tauntTime3: "Jean-Pierre se dívá na hodinky, pak na tebe, pak na hodinky.",
  tauntTime4: "FIS se ptá, proč je slalom na břečce.",
  tauntTime5: "Slyšíš instruktory, jak klientům vysvětlují, proč to 'není jejich chyba'.",

  // UNUSED paused: "Pozastaveno",
  resume: "Pokračovat",
  quitToMenu: "Odejít do menu",
  levelComplete: "Trať dokončena!",
  levelFailed: "Trať neúspěšná",
  tryAgain: "Zkusit znovu",
  coverage: "Pokrytí",
  time: "Čas",
  // UNUSED rating: "Hodnocení",
  nextLevel: "Další trať",
  // UNUSED replay: "Přehrát znovu",
  // UNUSED pressContinue: "Stiskněte mezerník nebo klepněte pro pokračování",
  pauseTitle: "⏸️ Pozastaveno",
  restart: "Restartovat",
  skipRun: "Přeskočit sjezd",
  newRun: "Nová sjezdovka",
  quit: "Odejít",
  menu: "Menu",
  levelSelect: "Výběr tratě",
  locked: "Uzavřeno",
   completeToUnlock: "Dokonči {name} pro odemknutí",
  // UNUSED target: "Cíl",
  tutorial: "Lyžařská škola",
  timeUsed: "Spotřebovaný čas",
  excellent: "Výborně!",
  good: "Dobrá práce!",
  passed: "Splněno",
  bonusFuel: "Spotřeba paliva",
  bonusFlawless: "Na první pokus",
  bonusSpeed: "Čas",
  bonusWinch: "Použití navijáku",
  bonusExplore: "Prozkoumané cesty",
  bonusPrecision: "Kvalita úpravy",
  retry: "Opakovat",
  gameComplete: "Hra dokončena!",
  viewCredits: "Zobrazit titulky",
  creditsTitle: "Gratulujeme!",
  creditsSubtitle: "Ovládl jsi Les Aiguilles Blanches",
  creditsCreatedBy: "Vytvořil",
  creditsDevelopedWith: "Vyvinuto s",
  creditsArtDirection: "Umělecká režie",
  creditsRetroInspiration: "Pocta retro klasikám jako SkiFree",
  creditsInspiredBy: "Inspirováno",
  creditsGroomers: "Ratrakáři ze Savoie",
  creditsDedication: "Pro noční posádky, které připravují sjezdovky, zatímco spíme",
  creditsThanks: "Díky za hru!",
  creditsSeeYou: "Brzy se uvidíme na sjezdovkách!",
  creditsLine: "Pojď, chlapče. Slunce vychází. Hora je připravena.",
  playAgain: "Hrát znovu",
  skipCredits: "Stiskni klávesu pro přeskočení",

  // Tutorial
  tutorialName: "Výukový program - První kroky",
  tutorialTask: "Nauč se základy úpravy",
  prologueLine: "4 ráno. Hora je tvoje. Do práce.",
  prologueSkip: "Stiskni pro pokračování",
  tutorialIntro: "Vítej v Les Aiguilles Blanches!",
  skipTutorial: "⏭️ Přeskakuji výuku… Klepni pro přehrání.",
  skipTutorialGamepad: "⏭️ Přeskakuji výuku… Stiskni tlačítko pro přehrání.",
  tutorialWelcome: "🏔️ Jean-Pierre, hlavní rolbař. Jeď po sjezdovce — použij {keys} nebo ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, hlavní rolbař. Jeď po sjezdovce — použij D-pad vlevo.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, hlavní rolbař. Jeď po sjezdovce — použij levou páčku nebo D-pad.",
  // UNUSED     tutorialControls: "🎮 Pro pohyb rolby použij {keys} nebo šipky ↑↓←→.",
  // UNUSED     tutorialControlsTouch: "🎮 Pro pohyb rolby použij D-pad ◀▲▼▶ vlevo.",
  // UNUSED     tutorialControlsGamepad: "🎮 Pro pohyb rolby použij levou páčku nebo D-pad.",
  // UNUSED     tutorialMove: "➡️ Tak do toho! Pohybuj se po sjezdovce — veškerý bílý sníh potřebuje úpravu.",
  // UNUSED     tutorialGroomIntro: "✅ Hezké! Teď se naučíme upravovat.",
  tutorialGroomAction: "❄️ Drž {groomKey} během jízdy pro úpravu sněhu. Sníh se vyrovná.",
  tutorialGroomActionTouch: "❄️ Drž tlačítko úpravy vpravo během jízdy pro úpravu sněhu.",
  tutorialGroomActionGamepad: "❄️ Drž {groomKey} během jízdy pro úpravu sněhu. Sníh se vyrovná.",
  tutorialGroomGoal: "📊 Správně! Uprav alespoň 60% před otevřením. Lyžaři přijíždějí!",
  // UNUSED   tutorialCoverage: "📊 Vidíš? Sníh je hladší! Pokračuj v úpravě sjezdovky.",
  // UNUSED   tutorialHUD: "📈 Sleduj panel nahoře: červená je palivo, zelená výdrž, bílá pokrytí. Čas běží!",
  // UNUSED   tutorialGoal: "🎯 Musíš upravit alespoň 60% sjezdovky před otevřením. Lyžaři přijíždějí!",
  // UNUSED tutorialFuel: "⛽ Pozor — jízda spotřebovává palivo. Na misích stavte u čerpací stanice.",
  tutorialComplete: "🏆 Výborně! Ovládl jsi základy. Připraven na první misi na zelené sjezdovce?",

  level_marmottesName: "Zelená sjezdovka - Les Marmottes",
  level_marmottesTask: "Uprav sjezdovku pro začátečníky",
  level_chamoisName: "Modrá sjezdovka - Le Chamois",
  level_chamoisTask: "Uprav efektivně před otevřením",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Připrav freestyle prvky",
  level_aigleName: "Červená sjezdovka - L'Aigle",
  level_aigleTask: "Uprav strmý terén, hlídej palivo",
  level_glacierName: "Červená sjezdovka - Le Glacier",
  level_glacierTask: "Nauč se používat naviják na strmých svazích",
  level_tubeName: "Half-pipe - Le Tube",
  level_tubeTask: "Udržuj half-pipe pro závody",
  level_verticaleName: "Černá sjezdovka - La Verticale",
  level_verticaleTask: "Noční operace s navijákem",
  level_colDangereuxName: "Lavinová zóna - Col Dangereux",
  level_colDangereuxTask: "Připrav vysoce rizikovou zónu",
  level_tempeteName: "Bouře - Obnova",
  level_tempeteTask: "Vyčisti sjezdovky po bouři",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - Finále FIS",
  level_coupeDesAiguillesTask: "Připrav všechny sjezdovky na závody",

  // Hazards
  cliffFall: "⚠️ POZOR! Spadl jsi z útesu! Mise selhala.",
  fuelEmpty: "⛽ BEZ PALIVA! Ani kapka nafty...",
  // UNUSED avalancheZone: "LAVINOVÁ ZÓNA",
  riskLevelHigh: "VYSOKÉ",
  avalancheWarning: "⚠️ NEBEZPEČÍ! Sněhová pokrývka je nestabilní! Opusť zónu!",
  avalancheTrigger: "🏔️💨 LAVINA SPUŠTĚNA! Žádný únik!",
  steepWarning: "⚠️ STRMÝ SVAH! Použij naviják ({winchKey}) nebo sklouzneš!",
  steepWarningNoWinch: "⚠️ STRMÝ SVAH! Zpomal a použij servisní cesty k objíždění!",
  tumble: "🔄 PŘEVRÁCENÍ! Rolba se převrátila na svahu!",

  // Taunts - Tumble
  tauntTumble1: "Naviják není na ozdobu. Je pro svahy jako je tento.",
  tauntTumble2: "Thierry zírá na škodu. Neříká nic. To je horší.",
  tauntTumble3: "Jean-Pierre ti ukázal, jak kotvit. Spal jsi?",
  tauntTumble4: "PistenBully stojí 400 000 €. Teda, stál.",
  tauntTumble5: "Svah vypadal zvládnutelně? Rolba nesouhlasila.",
  featureDestroyedKicker: 'Přejel jsi parkový prvek! Kicker je zničený.',
  featureDestroyedRail: 'Přejel jsi parkový prvek! Rail je zničený.',
  tauntFeature1: 'Ten prvek stavěli tři hodiny. Ty jsi ho srovnal za tři vteřiny.',
  tauntFeature2: 'Émilie si s tebou promluví o tom parkovém prvku.',
  tauntFeature3: 'Parková posádka právě viděla, jak ničíš jejich dílo.',
  tauntFeature4: 'Prvky jsou pro lyžaře, ne pro rolby. Objeď je!',
  tauntFeature5: 'O jeden prvek míň na zítřejší závod.',
  bonusPipeMastery: 'Ovládnutí halfpipe',

  // Taunts - Avalanche
  tauntAvalanche1: "Hora málokdy odpouští. Tentokrát neodpustila.",
  tauntAvalanche2: "Météo France hlásilo stupeň rizika 4. Četl jsi to?",
  tauntAvalanche3: "Horská služba najde rolbu na jaře. Možná.",
  tauntAvalanche4: "Marie slyší poplach v rádiu. Už ví, že jsi to ty.",
  tauntAvalanche5: "Horská služba zabezpečila ten sektor. Ty jsi ho odjistil.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Klasický pád. Výbava všude, důstojnost nikde.",
  tauntSkiWipeout2: "Útesu bylo jedno, jakou máš techniku.",
  tauntSkiWipeout3: "Horská služba se už směje. Viděli všechno.",
  tauntSkiWipeout4: "To se stane, když lyžuješ na vlastní sjezdovce.",
  tauntSkiWipeout5: "I kamzíci se při tom dopadu ušklíbli.",

  jeanPierreIntro: "Dobrá práce v tutoriálu. Teď to bude doopravdy — zelená sjezdovka, s časem a palivem k hlídání.",
  level_marmottesMid: "Vidíš tu záři na hřebenech? První svítání. Nejlepší část téhle práce — jen ty, stroj a hora, co se probouzí.",
  level_chamoisIntro: "Ahoj, jsem Émilie — JP tě posílá na modrou. Ukaž, že umíš víc než jen samety na zelené.",
  level_airZoneIntro: "Snowpark je MŮJ rajón — připravíme jim něco šílenýho! Každý modul musí sedět, jezdci na nás počítají.",
  level_aigleIntro: "L'Aigle je vážná věc. Hlídej palivo. Po servisních cestách se vrátíš nahoru — hledej žluto-černé sloupky.",
  level_glacierIntro: "Ahoj, já jsem Thierry — šéf bezpečnosti. Le Glacier je strmý. Zkontroloval jsem každou kotvu. Stiskni {winchKey} u sloupku pro připojení navijáku — a prosím tě, nepouštěj.",
  level_glacierIntroTouch: "Ahoj, já jsem Thierry — šéf bezpečnosti. Le Glacier je strmý. Zkontroloval jsem každou kotvu. Klepni na tlačítko navijáku u sloupku — a prosím tě, nepouštěj.",
  level_tubeIntro: "Zítra je contest na Tube! Chci čisté stěny, ostrý okraj a nula hrbolů.",
  level_verticaleIntro: "Noční akce na La Verticale: strmý svah, nebezpečné okraje. Naviják je povinný — použij 3 kotvení a drž se osy.",
  level_colDangereuxIntro: "Vysoké lavinové riziko na průsmyku — jedeme v protokolu lavinového zabezpečení. Drž se od zatížených zón a respektuj hranice.",
  level_tempeteIntro: "Bouře přešla. Dej si vin chaud — bude to chvíli trvat!",
  level_coupeDesAiguillesIntro: "Tohle je velká noc. FIS kontroluje zítra. Každá sjezdovka musí být perfektní — ukaž, co jsi se naučil.",
  marieWelcome: "Přijď se ohřát k Chez Marie. Dobrá tartiflette!",
  marieIntro: "Ahoj! Jsem Marie, vedu restauraci nahoře u sjezdovky. Stav se kdy chceš — teplé jídlo tu dělá zázraky!",

  // Changelog
  changelog_20260219_date: "19. února 2026",
  changelog_20260219: "🎬 Prolog pro nové hráče\n📖 Zjednodušený tutoriál\n🌦️ Náhodné počasí v menu\n🔗 Sdílitelné denní sjezdy\n🎥 Filmové titulky",
  changelog_20260222_date: "22. února 2026",
  changelog_20260222: "🚩 Vyvážení slalomových branek\n💬 Tlačítko zpětné vazby",
  changelog_20260223_date: "23. února 2026",
  changelog_20260223: "📲 Nainstaluj si hru do zařízení a hraj offline",
  changelog_20260220_date: "20. února 2026",
  changelog_20260220: "🗺️ Mapa tratí\n🎿 Lyžařská terminologie",
  changelog_20260217_date: "17. února 2026",
  changelog_20260217: "🏔️ Sedm tvarů sjezdovek\n🎯 Rozmanitost generování\n⚡ Plynulejší sjezd",
  changelog_20260216_date: "16. února 2026",
  changelog_20260216: "🎲 Dnešní sjezdovky",
  changelog_20260215_date: "15. února 2026",
  changelog_20260215: "⚡ Přepracování nočního renderu\n📱 Dotyková tlačítka v lyžování\n⌨️ Detekce rozložení klávesnice",
  changelog_20260214_date: "14. února 2026",
  changelog_20260214: "🎪 Bodování triků & komba\n🏂 Sjezdový postoj & fyzika halfpipe\n👁️ Lepší kontrast sjezdovek\n📱 Automatická úprava navijákem (dotyk)\n♿ Režim vysokého kontrastu",
  changelog_20260213_date: "13. února 2026",
  changelog_20260213: "🚩 Slalomové brány\n🏔️ Skoky na lyžích\n⚡ Vylepšený výkon\n🎹 Nokturní klavírní hudba\n🔊 Hlasitost motoru nastavitelná",
  changelog_20260212_date: "12. února 2026",
  changelog_20260212: "📋 Mapa tratí\n🔗 Přetržitelné lano navijáku\n🕹️ Diagnostika ovladače\n🍽️ Jídla od Marie\n❄️ Expozice mrazu",
  changelog_20260211_date: "11. února 2026",
changelog_20260211: "⛷️ Sjezd na lyžích po úpravě\n🎯 Kvalita úpravy\n🏔️ Barevně rozlišené strmé zóny\n🏗️ Park a triky",
  changelog_20260210_date: "10. února 2026",
  changelog_20260210: "🎵 Hudba a zvukové efekty\n🔈 Nastavení hlasitosti\n⏱️ Automaticky kalibrované časy\n⏭️ Přeskočit tutoriál\n🏔️ Přepracované lavinové zóny",
  changelog_20260209_date: "9. února 2026",
  changelog_20260209: "🏔️ Alpské obrazovky výher/proher\n❄️ Sněhová akumulace při bouři\n🏆 Bonus za bezchybnost\n🔊 Zvuky počasí a zvířat",
  changelog_20260208_date: "8. února 2026",
  changelog_20260208: "📊 Přepracovaný panel\n🏔️ Le Glacier a Coupe des Aiguilles\n🦅 Alpská zvířata\n🎨 Portréty postav\n🎮 Navigace klávesnicí a gamepadem",
  changelog_20260207_date: "7. února 2026",
  changelog_20260207: "🎨 Retro UI\n🎯 Bonusové cíle\n🕹️ Přemapování gamepadu\n🎮 Navigace v menu gamepadem",
  changelog_20260206_date: "6. února 2026",
  changelog_20260206: "🛤️ Sjízdné servisní cesty\n🕹️ Virtuální joystick\n🌍 5 jazyků",
  changelog_20260205_date: "5. února 2026",
  changelog_20260205: "🏔️ Skalní útesy\n🌙 Noční světla\n🔗 Mechanika navijáku\n⌨️ Navigace klávesnicí",
  changelog_20260204_date: "4. února 2026",
  changelog_20260204: "🎮 Podpora gamepadu\n📱 Dotykové ovládání\n💪 Výdrž\n💾 Uložení postupu\n♿ Přístupnost",
  changelog_20260203_date: "3. února 2026",
  changelog_20260203: "🚜 Spuštění: 9 tratí, lyžařská škola\n❄️ Úprava, palivo, laviny\n🏆 Titulky a postup",
  // Key names
  key_space: "MEZERNÍK",
  key_shift: "SHIFT",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTER",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "DEL",
  dailyRuns: "Dnešní sjezdovky",
  dailyRuns_dailyShift: "Denní směna",
  dailyRuns_randomRun: "Náhodná jízda",
  dailyRuns_rank: "Hodnocení",
  dailyRuns_seed: "Kód",
  // UNUSED   dailyRuns_start: "Zahájit kontrakt",
  dailyRuns_locked: "Dokonči všechny tratě pro odemknutí",
  dailyRuns_lockedShared: "Dokonči všechny tratě k odemknutí denních běhů a zahrání této sdílené sjezdovky",
  // UNUSED   dailyRun_levelName: "Kontrakt",
  dailyRun_levelTask: "Uprav sjezdovku na cílové pokrytí",
  dailyRuns_briefing: "Zadání",
  dailyRuns_target: "Cíl",
  dailyRuns_timeLimit: "Čas",
  dailyRuns_weather_clear: "Jasná obloha",
  dailyRuns_weather_light_snow: "Mírné sněžení",
  dailyRuns_weather_storm: "Bouřkové podmínky",
  dailyRuns_night: "Noční směna",
  dailyRuns_day: "Denní směna",
  rank_green: "Zelená",
  rank_blue: "Modrá",
  rank_red: "Červená",
  rank_black: "Černá",
  rank_park: "Park",
  share: "Sdílet",
  copied: "Odkaz zkopírován!",
  playSharedSeed: "Sdílený běh",
  dailyRunBriefingJP: "Sjezdovka musí být připravená, než otevřou vleky. Do toho.",
  dailyRunBriefingThierry: "Dej si pozor — strmé úseky a nestabilní sníh. Buď ve střehu.",
  dailyRunBriefingMarie: "Dneska v noci bude pořádná zima. Zastav se v restauraci zahřát, kdyby bylo potřeba.",
  dailyRunBriefingEmilie: "Další sjezdovka na řadě. Zkus překonat můj čas!"
};

export default cs;
